<template>
	<div class="">
		<div class="text-right">
			<button class="btn btn-primary" @click="showAdd()"><i class="fa fa-plus"></i> 添加权限分组 </button>
		</div>
		<div class="groupList">
			<div class="sgroupList" v-for="(item,index) in groupList">
				<i class="fa fa-vcard-o"></i>
				<span v-text="item.group_name" @click="showDetailDialog(item)"></span>
				<strong class="fr">></strong>
				<span class="delete" @click="showDelete(item)">×</span>
			</div>
		</div>
		<!--点击分组后，详情弹框-->
		<el-dialog title="权限详情" :visible.sync="detailDialogFlag" width="700px" >
			<el-form label-position="right" :label-width="formLabelWidth">
	          <el-form-item label="权限组名称：" >
	          	<el-input v-model="editGroup.group_name" auto-complete="off"></el-input>
	          </el-form-item>
	          <el-form-item label="开门方式：">
			    <el-checkbox-group v-model="openDoorWays">
			      <el-checkbox v-for="(doorItem,index) in rightItems" v-if="doorItem.type==3" :label="doorItem.number_id" :key="doorItem.number_id">{{doorItem.auth_name}}</el-checkbox>
			    </el-checkbox-group>
			  </el-form-item>
			  <el-form-item label="传感器：">
			    <el-checkbox-group v-model="senorRights">
			      <el-checkbox v-for="(sensorItem,index) in rightItems" v-if="sensorItem.type==4" :label="sensorItem.number_id" :key="sensorItem.number_id">{{sensorItem.auth_name}}</el-checkbox>
			    </el-checkbox-group>
			  </el-form-item>
			  <el-form-item label="视频监控">
			    <el-radio-group v-model="videoRight">
			      <el-radio v-for="(videoItem,index) in rightItems" v-if="videoItem.auth_name=='视频监控'" :label="videoItem.number_id" :key="videoItem.number_id">{{videoItem.operation}}</el-radio>
			    </el-radio-group>
			  </el-form-item>
			  <el-form-item label="风扇">
			    <el-radio-group v-model="fanRight">
			      <el-radio v-for="(fanItem,index) in rightItems" v-if="fanItem.auth_name=='风扇'" :label="fanItem.number_id" :key="fanItem.number_id">{{fanItem.operation}}</el-radio>
			    </el-radio-group>
			  </el-form-item>
			  <el-form-item label="空调">
			    <el-radio-group v-model="conditionRight">
			      <el-radio label="9" key="9">查看</el-radio>
			      <el-radio label="12" key="12">可控</el-radio>
			    </el-radio-group>
			  </el-form-item>
			  <el-form-item label="LED灯">
			    <el-radio-group v-model="ledRight">
			      <el-radio label="19" key="19">查看</el-radio>
			      <el-radio label="18" key="18">可控</el-radio>
			    </el-radio-group>
			  </el-form-item>
			  <el-form-item label="设备更名">
			    <el-radio-group v-model="devNameRight">
			      <el-radio label="15" key="15">查看</el-radio>
			      <el-radio label="16" key="16">可控</el-radio>
			    </el-radio-group>
			  </el-form-item>
	        </el-form>

			  <div slot="footer" class="dialog-footer">
			    <el-button @click="detailDialogFlag = false">取消</el-button>
			    <el-button v-if="!ifAdd" type="primary" @click="confirmModify()">保存</el-button>
			    <el-button v-if="ifAdd" type="primary" @click="confirmAdd()">添加</el-button>
			  </div>
		</el-dialog>
		<!--删除确认框-->
		<el-dialog title="提示框" :visible.sync="deleteDialogFlag" width="500px" >
		    <div class="userInfo">
				<h4>删除后不可恢复，确认删除吗？</h4>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="deleteDialogFlag = false">取消</el-button>
			    <el-button type="primary" @click="confirmDelete()">确定</el-button>
			  </div>
		</el-dialog>
	</div>
</template>
<script>
export default {
  data(){
    return {
    	groupList:[],
    	detailDialogFlag:false,
    	deleteDialogFlag:false,
    	formLabelWidth:"100px",
    	rightItems:[],
    	editGroup:{
    		group_name:""
    	},
    	openDoorWays:[],
    	senorRights:[],
    	videoRight:"",
    	fanRight:"",
    	conditionRight:"",
    	ledRight:"",
//  	设备更名权限
    	devNameRight:"",
    	
    	editRules:"",
    	ifAdd:false
    }
  },
  mounted(){
    this.$nextTick(function(){
    	this.getGroupList();
    	this.getRightsItems();
  	})
  },

  methods: {
//	获取权限选项
	getRightsItems(){
		let rightsItemsParams={
			uid:this.getCookie('uid'),
	  		time:Date.parse( new Date()),
	  		terminalId:4,
  		};
  		this.sign(rightsItemsParams);
  		this.$ajax.post(this.$store.state.domain+"/Home/AuthList/AuthList",this.$qs.stringify(rightsItemsParams),{
            emulateJSON: true
        }).then(res=>{
        	if(res.data.status==1){
        		this.rightItems = res.data.data || [];
        		
        	}else if(res.data.code==10008){
			      this.delCookie('username');
					this.$router.push('/login/');
					this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
        	}else{
        		//console.log(res.data.msg);
        	}
  		});
	},
//	strFormat(oriStr){
//		oriStr = JSON.stringify(oriStr).replace(/\[|]|"|"/g,'');
//		if(oriStr!=""){
//			oriStr = oriStr + ","
//		}
//	},
	showDelete(item){
		this.deleteDialogFlag = true;
		this.editGroup = item;
	},
	confirmDelete(){
		let groupListParams={
			uid:this.getCookie('uid'),
			username:this.getCookie('username'),
			group_name: this.editGroup.group_name,
			group_id: this.editGroup.id,
	  		time:Date.parse( new Date()),
	  		terminalId:4,
  		};
  		this.sign(groupListParams);
  		this.$ajax.post(this.$store.state.domain+"/Home/AuthDelete/AuthDelete",this.$qs.stringify(groupListParams),{
            emulateJSON: true
        }).then(res=>{
        	if(res.data.status==1){
        		this.deleteDialogFlag = false;
        		this.$message.success(res.data.msg);
        		this.getGroupList();
        		
        	}else if(res.data.code==10008){
			      this.delCookie('username');
					this.$router.push('/login/');
					this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
        	}else{
        		this.$message.error(res.data.msg);
        	}
  		});
	},
//	获取分组列表
	getGroupList(){
		let groupListParams={
			uid:this.getCookie('uid'),
	  		time:Date.parse( new Date()),
	  		terminalId:4,
  		};
  		this.sign(groupListParams);
  		this.$ajax.post(this.$store.state.domain+"/Home/GroupList/GroupList",this.$qs.stringify(groupListParams),{
            emulateJSON: true
        }).then(res=>{
        	if(res.data.status==1){
        		this.groupList = res.data.data || [];
        		
        	}else if(res.data.code==10008){
			      this.delCookie('username');
					this.$router.push('/login/');
					this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
        	}else{
        		//console.log(res.data.msg);
        	}
  		});
	},
	showAdd(){
		//		数据先重置为空
		this.editGroup = {};
		this.openDoorWays = [];
		this.senorRights = [];
		this.videoRight = "";
		this.fanRight = "";
		this.conditionRight = "";
		this.ledRight = "";
		this.devNameRight = "";
		this.editRules = "";
		this.ifAdd = true;
		this.detailDialogFlag = true;
	},
//	添加权限
	confirmAdd(){
		this.editRules =JSON.stringify(this.openDoorWays).replace(/\[|]|"|"/g,'')+","
						+JSON.stringify(this.senorRights).replace(/\[|]|"|"/g,'')+","
						+(this.videoRight)+","
						+(this.fanRight)+","
						+(this.conditionRight)+","
						+(this.ledRight)+","
						+(this.devNameRight);
		let groupAddParams={
			uid:this.getCookie('uid'),
			username:this.getCookie('username'),
			groupName: this.editGroup.group_name,
			id: this.editRules,
			token:this.getCookie('token'),
	  		time:Date.parse( new Date()),
	  		terminalId:4,
  		};
  		this.sign(groupAddParams);
  		this.$ajax.post(this.$store.state.domain+"/Home/AuthGroup/AuthGroup",this.$qs.stringify(groupAddParams),{
            emulateJSON: true
        }).then(res=>{
        	if(res.data.status==1){
        		this.detailDialogFlag = false;
        		this.$message.success(res.data.msg);
        		this.getGroupList();
        	}else if(res.data.code==10008){
			      this.delCookie('username');
					this.$router.push('/login/');
					this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
        	}else{
        		this.$message.error(res.data.msg)
        	}
  		});
  		
	},
//	点击权限组,弹出详情
	showDetailDialog(item,index){
		this.ifAdd = false;
		this.detailDialogFlag = true;
//		数据先重置为空
		this.editGroup = {};
		this.openDoorWays = [];
		this.senorRights = [];
		this.videoRight = "";
		this.fanRight = "";
		this.conditionRight = "";
		this.ledRight = "";
		this.devNameRight = "";
		this.editRules = "";
		let showDetailDialogParams={
			uid:this.getCookie('uid'),
			auth_id:item.id,
	  		time:Date.parse( new Date()),
	  		terminalId:4,
  		};
  		this.sign(showDetailDialogParams);
  		this.$ajax.post(this.$store.state.domain+"/Home/GroupDetails/GroupDetails",this.$qs.stringify(showDetailDialogParams),{
            emulateJSON: true
        }).then(res=>{
        	
        	if(res.data.status==1){
        		
        		this.editGroup = res.data.data || {};
        		if(this.editGroup && this.editGroup.rules!=""){
        			var rules = this.editGroup.rules.split(",");
        			for(var i=0;i<rules.length;i++){
        				if(rules[i]=="1"||rules[i]=="2"||rules[i]=="3"){
        					this.openDoorWays.push(rules[i]);
        				}else if(rules[i]=="4"||rules[i]=="5"||rules[i]=="6"||rules[i]=="17"||rules[i]=="20"||rules[i]=="21"||rules[i]=="22"||rules[i]=="23"){
        					this.senorRights.push(rules[i]);
        				}else if(rules[i]=="7"||rules[i]=="10"){
        					this.videoRight = rules[i];
        				}else if(rules[i]=="8"||rules[i]=="11"){
        					this.fanRight = rules[i];
        				}else if(rules[i]=="9"||rules[i]=="12"){
        					this.conditionRight = rules[i];
        				}else if(rules[i]=="9"||rules[i]=="12"){
        					this.conditionRight = rules[i];
        				}else if(rules[i]=="18"||rules[i]=="19"){
        					this.ledRight = rules[i];
        				}else if(rules[i]=="15"||rules[i]=="16"){
        					this.devNameRight = rules[i];
        				}
        			}
        			
        			
        		}
        	}else if(res.data.code==10008){
			      this.delCookie('username');
					this.$router.push('/login/');
					this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
        	}else{
        		//console.log(res.data.msg);
        	}
  		});
	},
//	保存修改
	confirmModify(){
		this.editRules = JSON.stringify(this.openDoorWays).replace(/\[|]|"|"/g,'')+","
						+JSON.stringify(this.senorRights).replace(/\[|]|"|"/g,'')+","
						+(this.videoRight)+","
						+(this.fanRight)+","
						+(this.conditionRight)+","
						+(this.ledRight)+","
						+(this.devNameRight)
		let groupListParams={
			uid:this.getCookie('uid'),
			username:this.getCookie('username'),
			group_name: this.editGroup.group_name,
			auth_id: this.editGroup.id,
			rules: this.editRules,
	  		time:Date.parse( new Date()),
	  		terminalId:4,
  		};
  		this.sign(groupListParams);
  		this.$ajax.post(this.$store.state.domain+"/Home/AuthEdit/AuthEdit",this.$qs.stringify(groupListParams),{
            emulateJSON: true
        }).then(res=>{
        	if(res.data.status==1){
        		this.detailDialogFlag = false;
        		this.$message.success(res.data.msg);
        		this.getGroupList();
        	}else if(res.data.status==10008){
			      this.delCookie('username');
					this.$router.push('/login/');
					this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
        	}else{
        		this.$message.error(res.data.msg)
        	}
  		});
	},
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/device/rightsManage.vue